import Vue from "vue";
import { HttpException } from "../exceptions/http/HttpException";

export function handleError(error: any) {
  Vue.$log.error(error);
  if (error instanceof HttpException) {
    Vue.$toast.error(error.message);
  }
}
